export default function () {
    return {
        invoicesPerPage: 25,
        paidInvoicesPerPage: 25,
    };
}
